import { css } from '@emotion/core';
import { fontWeights } from '../../../styles/typography';
import { colorsPalette } from '../../../styles/colors';

export const contactLineNumber = css({
  alignItems: 'center',
  color: colorsPalette.black,
  display: 'flex',
  textDecoration: 'none',
  ['i']: {
    color: colorsPalette.grey,
  },
});

export const openStatus = css({
  color: colorsPalette.grey,
  display: 'inline-block',
  fontWeight: fontWeights.medium,
  margin: '0 16px 0 10px',
});
